import  { instance  } from "../api";
const fetchActifByClient =  (setActifAttributes, selectedClient) => {
 
      instance.get(`/api/actifs/client/${selectedClient}`)
      .then((result)=>  { setActifAttributes({ actifs: result.data }
        )
    //   console.log('result.data', result.data)
     })    
              
    .catch ((error) =>{console.log('error', error)
      
    })
};

export default fetchActifByClient;

export const contacterActif= async (actifId, data)=>{
  try 
  { 
    const response =  await instance.post(`/api/actifs/${actifId}/formulaire/information`, data );
   
     return response
 }
  catch(error ) {
     console.error('Erreur Axios:', error);
     throw new Error(`Erreur lors de l'envoi : ${error.response?.status || error.message}`);
   };
  
 }
 export const rechercheActif = async (idClient, search, setActifAttributes) => {
  try {
    const result = await instance.post(`/api/actifs/client/${idClient}/search`, search);
    setActifAttributes({ actifs: result.data });
    // console.log('result.data', result.data)
  } catch (error) {
    console.log('error', error);
  }
}